import { State } from "./types";

export const initialState: State = {
	desktopsWithSystems: [],
	selectedDesktopSystem: null,
	desktopRequests: [],
	locations: [],
	printerConfigs: [],
	printJobs: [],
};
